/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInactiveAccountHoldersForAccountInternal} from '../api'

 export const useQueryGetInactiveAccountHoldersForAccountInternal = createReactQueryHook('getInactiveAccountHoldersForAccountInternal', getInactiveAccountHoldersForAccountInternal)
